import type {
  PublicAppointmentParticipantInput,
  PublicContactMethodResponse,
  PublicContactMethodsResponse,
} from "../../../api/public/appointment-portal"

const normalizeEmail = (value?: string | null): string | null => {
  const text = value?.trim().toLowerCase()

  return text && text.includes("@") ? text : null
}

const maskEmail = (value: string): string => {
  const [local = "", domain = ""] = value.split("@")
  const visible = local.slice(0, 1) || "*"

  return `${visible}${local.length > 1 ? "***" : ""}@${domain}`
}

const pendingEmailMethod = (email: string): PublicContactMethodResponse => ({
  id: `pending:email:${email}`,
  kind: "EMAIL",
  label: "Neu angegebene E-Mail",
  masked_value: maskEmail(email),
  channels: [
    {
      channel: "EMAIL",
      label: "E-Mail",
      is_enabled: true,
    },
  ],
  deletion_requested: false,
  is_pending: true,
  read_only: true,
})

export const buildPendingContactMethodsFromParticipant = (
  participant: PublicAppointmentParticipantInput,
): PublicContactMethodResponse[] => {
  const email = normalizeEmail(participant.email)

  return email ? [pendingEmailMethod(email)] : []
}

export const mergePendingContactMethods = (
  state: PublicContactMethodsResponse | null,
  pendingMethods: PublicContactMethodResponse[],
): PublicContactMethodsResponse | null => {
  if (!pendingMethods.length) return state

  if (!state) {
    return {
      available: true,
      contact_methods: pendingMethods,
    }
  }

  if (!state.available) return state

  const existingKeys = new Set(
    state.contact_methods.map((method) => `${method.kind}:${method.masked_value}`),
  )
  const missingPending = pendingMethods.filter(
    (method) => !existingKeys.has(`${method.kind}:${method.masked_value}`),
  )

  if (!missingPending.length) return state

  return {
    ...state,
    contact_methods: [...state.contact_methods, ...missingPending],
  }
}
